import React, { ReactElement, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableHead from "@material-ui/core/TableHead";
import Paper from "@material-ui/core/Paper";
import formatDate from "../../utils/formatDate";
import { getUsers } from "../../services/user.service";
import { UserColumn, UserRow } from "../../types/user.type";

const columns: UserColumn[] = [
  // { id: "id", label: "UID", align: "center" },
  { id: "email", label: "Email", align: "center" },
  // { id: "licenseNo", label: "License No.", align: "center" },
  { id: "firstname", label: "FirstName", align: "center" },
  { id: "lastname", label: "LastName", align: "center" },
  { id: "role", label: "Role", align: "center" },
  { id: "createdAt", label: "Created At", align: "center", minWidth: 100 },
];

const useStyles = makeStyles({
  table: {
    minWidth: 500,
  },
});

const UserTable: React.FC = (): ReactElement => {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState<UserRow[]>([]);
  const [count, setCount] = useState(0);

  const { data } = useQuery(
    ["users", page, rowsPerPage],
    () => getUsers({ skip: page * rowsPerPage, take: rowsPerPage }),
    { keepPreviousData: true, staleTime: 5000 }
  );

  useEffect(() => {
    if (data) {
      setRows(data.data);
      setCount(data.count);
    }
  }, [data]);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  console.log(data);

  return (
    <div className="w-full">
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="custom pagination table">
          <TableHead>
            <TableRow>
              {columns.map((column, i) => (
                <TableCell
                  key={i}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  <p className="text-gray-600">{column.label}</p>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, i) => (
              <TableRow
                key={i}
                className={`${
                  i % 2 === 0 ? `bg-gray-50` : ""
                } hover:bg-blue-50`}
              >
                {/* <TableCell align="center">
                  <p className="text-gray-600">{row.id}</p>
                </TableCell> */}
                <TableCell align="center">
                  <p className="text-gray-600">{row.email}</p>
                </TableCell>
                {/* <TableCell align="center">
                  <p className="text-gray-600">{row.licenseNo}</p>
                </TableCell> */}
                <TableCell align="center">
                  <p className="text-gray-600">{row.firstname}</p>
                </TableCell>
                <TableCell align="center">
                  <p className="text-gray-600">{row.lastname}</p>
                </TableCell>
                <TableCell align="center">
                  <p className="text-gray-600">
                    {row.role && row.role.name ? row.role.name : "-"}
                  </p>
                </TableCell>
                <TableCell align="center">
                  <p className="text-gray-600">{formatDate(row.createdAt)}</p>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[10, 15, 25]}
                colSpan={7}
                count={count}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { "aria-label": "rows per page" },
                  native: true,
                }}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
      <div className="h-7" />
    </div>
  );
};

export default UserTable;
